module.exports = __webpack_public_path__ + "static/Eliza1-f11f3c44dad33010de67d350e4a98fad.webp";